"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var bind_1 = require("./bind");
Object.defineProperty(exports, "bind", { enumerable: true, get: function () { return bind_1.bind; } });
var bind_all_1 = require("./bind-all");
Object.defineProperty(exports, "bindAll", { enumerable: true, get: function () { return bind_all_1.bindAll; } });
